import React from 'react';
import AuthService from './authService.js';
import TpEvaluatorItem from '../Domain/TpEvaluatorItem.js';
import TpEvaluatorEmailCampaignItem from '../Domain/TpEvaluatorEmailCampaignItem.js';
import TpEvaluatorTextMessageItem from '../Domain/TpEvaluatorTextMessageItem.js';
import TpEvaluatorPersonaItem from '../Domain/TpEvaluatorPersonaItem.js';
import TpEvaluatorSchedulingItem from '../Domain/TpEvaluatorSchedulingItem.js';
import SearchParams from '../Elements/SearchParams';
import TpEvaluatorSearchParams from '../Contents/ThirdParty/TpEvaluator/TpEvaluatorSearchParams';
import TpEvaluatorEmailCampaignSearchParams from '../Contents/ThirdParty/TpEvaluator/TpEvaluatorEmailCampaignSearchParams';
import TpEvaluatorTextMessageSearchParams from '../Contents/ThirdParty/TpEvaluator/TpEvaluatorTextMessageSearchParams';
import TpEvaluatorPersonaSearchParams from '../Contents/ThirdParty/TpEvaluator/TpEvaluatorPersonaSearchParams';
import TpEvaluatorSchedulingSearchParams from '../Contents/ThirdParty/TpEvaluator/TpEvaluatorSchedulingSearchParams';

export default class TpEvaluatorService extends React.Component {
  static GetAllItemBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(
      searchItem,
      TpEvaluatorSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    const url = `/api/TpEvaluator/GetItems/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunction(url);
  }

  static SearchEvaluatorsByEmail(email) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpEvaluator/GetEvaluatorsByEmail/${encodeURIComponent(email)}?clearCache=true`
    );
  }

  // CD-5527: link/unlink a duplicate profile under a primary one. data = { TpEvaluatorId, PrimaryTpEvaluatorId,
  // Reason }. The backend answers a plain confirmation string; business-rule failures arrive as a ProblemDetails,
  // which authService turns into an Error with isBusinessError = true and the backend message.
  static AttachToPrimary(data) {
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/TpEvaluator/AttachTpEvaluatorToPrimaryTpEvaluator',
      JSON.stringify(data)
    );
  }

  static DetachFromPrimary(data) {
    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/TpEvaluator/DetachTpEvaluatorFromPrimaryTpEvaluator',
      JSON.stringify(data)
    );
  }

  static ConvertDBItems(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpEvaluatorItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static async ExportToExcelForView(searchItem) {
    const searchParams = {
      SearchItem: searchItem,
    };
    const url = '/api/TpEvaluator/ExportToExcelForView';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(searchParams));
  }

  //#region Export Views

  static GetAllItemBySearchingForEmailCampaign(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(
      searchItem,
      TpEvaluatorEmailCampaignSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpEvaluator/GetAllItemBySearchingForEmailCampaign/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertDBItemsForEmailCampaign(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpEvaluatorEmailCampaignItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }
  //#endregion

  //#region Text Message Export

  static GetAllItemBySearchingForTextMessage(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(
      searchItem,
      TpEvaluatorTextMessageSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpEvaluator/GetAllItemBySearchingForTextMessage/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertDBItemsForTextMessage(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpEvaluatorTextMessageItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }
  //#endregion

  //#region Persona Export

  static GetAllItemBySearchingForPersona(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(
      searchItem,
      TpEvaluatorPersonaSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpEvaluator/GetAllItemBySearchingForPersona/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertDBItemsForPersona(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpEvaluatorPersonaItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }
  //#endregion

  //#region Scheduling Export

  static GetAllItemBySearchingForScheduling(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(
      searchItem,
      TpEvaluatorSchedulingSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    return AuthService.getInstance().CallBackendFunction(
      `/api/TpEvaluator/GetAllItemBySearchingForScheduling/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertDBItemsForScheduling(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TpEvaluatorSchedulingItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }
}
